// 必要なライブラリやコンポーネントをインポート
import { useSearchParams } from "react-router-dom"; // URLクエリパラメータを取得するためのフック
import UserCollectionTemplate from "../templates/UserCollectionTemplate"; // 資料一覧表示用のテンプレート
import { UCListType } from "../organisms/UCList"; // 資料リストの型定義
import { useEffect, useState } from "react"; // Reactのフック
import axios from "axios"; // HTTPリクエスト用
import { UCItemType } from "../atoms/UCItem"; // 資料アイテムの型定義
import { useRecoilValue } from "recoil"; // Recoilの状態管理用フック
import userState from "../../recoil/atoms/userState"; // ユーザー状態を管理するRecoilアトム

/** 
 * UserCollectionPageコンポーネント
 * ユーザー向けの「資料一覧」ページを表示するためのコンポーネント
 * 検索クエリに基づいて資料リストを取得し、テンプレートで表示
 */
const UserCollectionPage = () => {
    // URLのクエリパラメータを取得
    const [searchParams] = useSearchParams();

    // 資料リストデータの状態を管理
    const [data, setData] = useState<UCListType[]>([]);

    // グローバルなユーザーデータを取得
    const userData = useRecoilValue(userState);

    // コースタイトル一覧（コースIDに対応）
    const COURSE_TITLE: string[] = [
      "",
      "新入社員向け 初級コース",
      "ExcelVBA/AccessVBA 中級コース",
      "仮想Server構築(Esxi) 中級コース",
      "フロント・バックエンド開発 上級コース",
      "仮想Server構築(コンテナ) Amazon AWS構築 上級コース"
    ];

    // 資料リストを取得する非同期関数
    const getList = async () => {
        // クエリパラメータlvが有効な値でない場合は処理を終了
        if (!["1", "2", "3", "4", "5"].includes(searchParams.get("lv") ?? '')) return;

        const items: UCItemType[] = []; // 資料アイテムの配列を初期化

        // サーバーに資料リスト取得リクエストを送信
        await axios.post(process.env.REACT_APP_BE_HOST + 'documents/documentList', {
            "courseId": searchParams.get("lv"), // コースIDをリクエストボディに含める
            "genreId": 1 // ジャンルID（固定値）
        }, {
            withCredentials: true // 認証情報を含む
        })
        .then((res: any) => {
            // レスポンスデータを解析し、資料アイテムを構築
            res.data?.documentList?.forEach((d: any) => {
                items.push({
                    title: d.documentName, // 資料名
                    memo: d.searchResultText, // 検索結果の説明文
                    url: (d.workbookFlg ? "test?no=" : "material?id=") + d.documentId, // 資料リンクURL
                    disabled: d.documentAuth && d.documentAuth > userData.userType, // ユーザー権限による無効化フラグ
                    img: d.explanatoryImageData, // 説明用画像データ
                    thumbnailPath: d.thumbnailPath, // サムネイルパス
                });
            });

            // 資料リストデータを状態にセット
            setData([{
                category: COURSE_TITLE[Number(searchParams.get("lv"))], // コースタイトル
                items // 資料アイテム配列
            }]);
        })
        .catch((e: any) => {
            // エラーハンドリング
            console.log(e);
        });
    };

    // コンポーネントの初回レンダリング時に資料リストを取得
    useEffect(() => {
        getList();
    }, []);

    // テンプレートコンポーネントに資料データを渡してレンダリング
    return (
        <UserCollectionTemplate data={data} />
    );
};

// UserCollectionPageコンポーネントをデフォルトエクスポート
export default UserCollectionPage;
